import {
  Button,
  Col,
  Form,
  Image,
  Input,
  message,
  Modal,
  Row,
  Upload,
} from "antd";
import React, { useState } from "react";
import notfound from "../assets/images/not_found.png";
import { Severty, ShowToast } from "../helper/toast";
import lang from "../helper/langHelper";
import { UploadOutlined } from "@ant-design/icons";
import callApi from "../constants/API/CallApi";
import { getProfile, updateProfile } from "../constants/API/API";
import useApi from "../hooks/useApi";
import { uploadFileToS3 } from "../helper/uploadImage";
import { emailDomainValidation } from "../helper/functions";
import ImgCrop from "antd-img-crop";

const EditProfile = ({ show, hide, refresh, setUserProfile }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState("");
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    // "image/avif",
    // "image/webp",
  ];

  useApi({
    callback: getProfile,
    dependencies: [show],
    onSuccess: (res) => {
      const { getAdmin } = res;
      form.setFieldsValue({ ...getAdmin });
      if (getAdmin?.profilePic && getAdmin?.profilePic != undefined) {
        setImage(getAdmin.profilePic);
      } else {
        setImage([notfound]);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const beforeUpload = (file) => {
    if (FileType.includes(file.type)) {
    } else {
      message.error("File format is not correct");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error(`Image must be smaller than 5 MB!`);
      return false;
    }
    return true;
  };

  const handleChange = async (event) => {
    const { file } = event;

    setLoading(true); // Set uploading to true when the upload starts
    uploadFileToS3({ file, dirName: "tutorly/profile" })
      .then((data) => {
        const fileData = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: data.Location,
          thumbUrl: data.Location,
        };
        setFile([fileData]);
        setImage(data.Location);
        form.setFieldsValue({ image: data.Location });
        setLoading(false); // Set uploading to false when the upload completes
      })
      .catch((err) => {
        console.error(err);
        setLoading(false); // Set uploading to false if the upload fails
      });
  };

  const onEditProfile = (values) => {
    const { email, name } = values;

    if (file.length <= 0 && !image)
      return ShowToast("Please select the profile Image ", Severty.ERROR);
    const payload = {};
    setLoading(true);
    payload.email = email;
    payload.name = name;
    payload.profilePic = Array.isArray(image)
      ? null
      : image.length > 0
      ? image
      : null;

    callApi({
      callback: updateProfile,
      payload: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          setUserProfile(data.data);

          refresh();
          // setUserProfile(prev=>{{...prev,...data.getAdmin}});
          // window.location.reload();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleRemove = async () => {
    setFile([]);
    setImage("");
  };

  return (
    <Modal
      open={show}
      // title={`${data ? "Edit Profile" : ""}`}
      okText={lang("Ok")}
      cancelText={lang("Cancel")}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <h4 className="modal_title_cls">{lang("Edit Profile")}</h4>
      <Form id="create" form={form} onFinish={onEditProfile} layout="vertical">
        <Row>
          <Col span={24}>
            <Form.Item
              label={lang("Name")}
              name="name"
              normalize={(val)=>val?.trimStart()}
              rules={[
                { required: true, message: lang("Please enter the name!") },
                {
                  pattern: new RegExp(/^[a-zA-Z ]*$/),
                  message: lang("Only Alphabetic Characters Allowed"),
                },
              ]}
            >
              <Input placeholder={lang("Enter Name")} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Email Address"
              name="email"
              normalize={(val)=>val?.trimStart()}
              rules={[
                {
                  type: "email",
                  message: "The input is not a valid E-mail!",
                },
                {
                  required: true,
                  message: "Please enter the email!",
                },
                {
                  max: 100, // Optional: Add max length validation
                  message: "Email cannot be longer than 100 characters",
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Optional: Custom pattern for stricter validation
                  message: "Please enter a valid email address",
                },
                emailDomainValidation,
              ]}
            >
              <Input placeholder="Enter Email Address" disabled />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item  label="Upload Profile" name="image">
              <ImgCrop showGrid rotationSlider aspectSlider showReset modalClassName="upload-button-main-crop" >
                <Upload
                  listType="picture"
                  maxCount={1}
                  beforeUpload={beforeUpload}
                  customRequest={handleChange}
                  onRemove={handleRemove}
                  fileList={file}
                  action=""
                >
                  {file && file.length > 0 ? null : (
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  )}
                </Upload>
              </ImgCrop>
              {image && (
                <div className="mt-3">
                  <Image width={300} src={image}></Image>
                </div>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditProfile;
